import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "relative pb-3 steps-container" }
const _hoisted_2 = { class: "mx-4 flex flex row justify-content-between" }

import { ref, toRefs } from 'vue';
import Step from './Step.vue';

interface PropsInterface {
  id: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Steps',
  props: {
    id: {}
  },
  setup(__props: any) {

const props = __props;
const { id } = toRefs(props);

const isSelectedClass = (key: number) => {
  return key === id.value ? 'selected' : '';
};

const steps = ref([
  { title: 'Add Tenant', id: 0 },
  { title: 'Add Organization', id: 1 },
  { title: 'Add Admin', id: 2 },
]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("hr", { class: "w-full bg-white absolute rule right-0 left-0" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(steps.value, (step) => {
        return (_openBlock(), _createBlock(Step, {
          key: step.id,
          "class-name": isSelectedClass(step.id),
          step: step
        }, null, 8, ["class-name", "step"]))
      }), 128))
    ])
  ]))
}
}

})